var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfieGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 9.61234C9.36112 9.01822 10.6385 9.01822 11.6664 9.61234M7.35686 7.64306C8.65861 8.9448 8.65861 11.0554 7.35686 12.3571C6.05512 13.6589 3.94457 13.6589 2.64281 12.3571C1.34107 11.0554 1.34107 8.94481 2.64281 7.64306C3.94456 6.34131 6.05511 6.34131 7.35686 7.64306ZM17.3569 7.64306C18.6586 8.9448 18.6586 11.0554 17.3569 12.3571C16.0551 13.6589 13.9446 13.6589 12.6428 12.3571C11.3411 11.0554 11.3411 8.94481 12.6428 7.64306C13.9446 6.34131 16.0551 6.34131 17.3569 7.64306Z",
    stroke: "#51525C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieGlasses);
export default __webpack_public_path__ + "static/media/selfie-glasses.9493fccfef0bee0984ed292e494ef97f.svg";
export { ForwardRef as ReactComponent };